import { useMemo } from "react";

type EventDateProps = {
  start: string;
  end: string;
  reoccurring: boolean;
};

function EventDate(props: EventDateProps) {
  const timeZone = useMemo(() => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }, []);

  const timeZoneShort = useMemo(() => {
    const date = new Date();
    const dateString = date.toLocaleTimeString("en-US", {
      timeZoneName: "short",
    });
    const timezoneAbbreviation = dateString.split(" ")[2];
    return timezoneAbbreviation;
  }, []);

  const eventDate = useMemo(() => {
    const startDate = new Date(props.start);
    const endDate = new Date(props.end);

    // Convert the dates to the local timezone
    const localStartDate = new Date(
      startDate.toLocaleString("en-US", { timeZone: timeZone })
    );
    const localEndDate = new Date(
      endDate.toLocaleString("en-US", { timeZone: timeZone })
    );

    // Format the dates
    const formattedDate = localStartDate.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    const startTime = localStartDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    const endTime = localEndDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    // Function to add the ordinal suffix
    const ordinalSuffix = (n: number) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return s[(v - 20) % 10] || s[v] || s[0];
    };

    const day = localStartDate.getDate();
    const formattedDay = day + ordinalSuffix(day);

    const [dayName, monthName, , year] = formattedDate.split(" ");
    const formattedDateWithOrdinal = `${dayName} ${monthName} ${formattedDay}, ${year}`;

    if (props.reoccurring) {
      return `${startTime} - ${endTime} ${timeZoneShort}`;
    }

    return `${formattedDateWithOrdinal} ${startTime} - ${endTime} ${timeZoneShort}`;
  }, [props.start, props.end, props.reoccurring, timeZone, timeZoneShort]);

  return <>{eventDate}</>;
}

export default EventDate;
